import { render } from "./VposChiTietCuaHang.vue?vue&type=template&id=1509972d&style=font-family%3Asystem-ui"
import script from "./VposChiTietCuaHang.vue?vue&type=script&lang=js"
export * from "./VposChiTietCuaHang.vue?vue&type=script&lang=js"

import "./VposChiTietCuaHang.vue?vue&type=style&index=0&id=1509972d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__